export default "/images/login-header.png?99c66bfc8c665f96b299d1982d479522";